export const JWT_TOKEN_HANDLER_SERVICE_NAME = 'tao-manual-scoring';
